/**
 * KAN-753: компактный индикатор "Менеджер: Имя" в шапке кабинета. Список тот же,
 * что в карточках (ManagerSelect), с пунктом "Не выбран". Без менеджеров у
 * организации не показывается. KAN-811: у вошедшего менеджера (роль MANAGER)
 * только его имя, без выбора.
 */
import { ManagerSelect } from '@/components/managers/ManagerSelect';
import { useSessionManager } from '@/hooks/useSessionManager';

export const SESSION_MANAGER_NONE_LABEL = 'Не выбран';

export function SessionManagerIndicator() {
  const { available, manager, select, locked } = useSessionManager();
  if (!available) return null;

  return (
    <div
      className="flex min-w-0 items-center gap-2 text-sm"
      data-testid="session-manager-indicator"
    >
      <span className="hidden shrink-0 text-gray-500 sm:inline">Менеджер:</span>
      {locked ? (
        <span className="truncate font-medium text-gray-900">{manager?.full_name}</span>
      ) : (
        <div className="w-36 min-w-0 shrink sm:w-56">
          <ManagerSelect
            value={manager}
            onSelect={select}
            noneLabel={SESSION_MANAGER_NONE_LABEL}
            testId="session-manager-select"
          />
        </div>
      )}
    </div>
  );
}
